// extracted by mini-css-extract-plugin
export default {"gridContainer":"OrderDetailsGrid_gridContainer__rGcGT","gridOverlay":"OrderDetailsGrid_gridOverlay__gpLzM"};